import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ChatIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M16.75 1H3.25C2.01 1 1 2.01 1 3.25v10.125c0 1.24 1.01 2.25 2.25 2.25h1.125v2.813a.562.562 0 0 0 .923.431l3.893-3.244h7.559c1.24 0 2.25-1.01 2.25-2.25V3.25C19 2.01 17.99 1 16.75 1Zm1.125 12.375c0 .62-.505 1.125-1.125 1.125H8.988a.562.562 0 0 0-.36.13L5.5 17.238v-2.174a.563.563 0 0 0-.563-.563H3.25c-.62 0-1.125-.505-1.125-1.125V3.25c0-.62.505-1.125 1.125-1.125h13.5c.62 0 1.125.505 1.125 1.125v10.125Z"
  })
});
export default ChatIcon;